import type { SVGProps } from "react";
import * as React from "react";

const SvgCreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1 9a1 1 0 0 0 0 2zm22 2a1 1 0 1 0 0-2zM3 5h18V3H3zm18 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v12h2V6zm0 12a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H3v2h18zM3 19a1 1 0 0 1-1-1H0a3 3 0 0 0 3 3zm-1-1V6H0v12zM2 6a1 1 0 0 1 1-1V3a3 3 0 0 0-3 3zm-1 5h22V9H1z"
    />
  </svg>
);
export default SvgCreditCard;
